import React from "react";
import { BiErrorAlt } from "react-icons/bi";
import { classBt, classbtVermelho } from "../../Utils/Types";

type Props = {
    titulo: string,
    caption: string,
    buttonConfirmClick: React.MouseEventHandler<HTMLButtonElement>,
    buttonCloseModalClick?: () => void,
    loading?: boolean,
    visible?: boolean,
    confirmCaption?: string,
}

export const Modal = React.memo(({ titulo, caption, buttonConfirmClick, loading, visible, confirmCaption, buttonCloseModalClick }: Props) => {

    const handleModalClose = () => {

        if (buttonCloseModalClick) {

            buttonCloseModalClick()

        } else {
            
            let modal = document.getElementById('modal');

            if (modal) {
                modal.style.visibility = 'hidden';
                let modalContent = document.getElementById('modal-content');

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]');
                    modalContent.classList.remove('mt-24');
                }
            }
        }
    }

    return (

        <div id="modal" style={{ visibility: visible ? "visible" : "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal-content" className={`relative flex flex-col w-[85%] sm:w-[70%] md:w-[60%] lg:w-[40%] xl:w-[30%] h-[250px] bg-white dark:bg-slate-600 rounded-lg ${visible ? 'mt-24' : 'mt-[-400px]'} transition-all duration-300 justify-center items-center`}>

                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center`}>

                    <div className={`mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#8f3838] border-2 border-[#FC5F4D] shadow-sm shadow-black mt-6 mb-4`}>
                        <BiErrorAlt className={`text-red-400 w-10 h-10`} />
                    </div>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full pt-4`}>

                    <div>
                        <span className={`flex justify-center text-base font-semibold  text-slate-800 dark:text-slate-200`}>{titulo}</span>
                    </div>

                    <div className={`mt-1 mb-6 w-full h-auto px-2`}>
                        <p className={`text-base text-center text-slate-500 dark:text-slate-200 pl-2 pr-2 w-full h-full flex justify-center items-center`}>{caption}</p>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button disabled={loading}
                        onClick={handleModalClose}
                        className={`${classBt} text-black dark:text-slate-100 ring-1 ring-inset ring-slate-300 hover:ring-black dark:ring-slate-400 dark:hover:bg-slate-500 max-w-[150px]`} >

                        CANCELAR
                    </button>

                    <button disabled={loading}
                        onClick={buttonConfirmClick}
                        className={`${classbtVermelho} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {confirmCaption && loading ? 'AGUARDE' : confirmCaption ? confirmCaption : 'SAIR'}
                       
                    </button>

                </div>

            </div>

        </div>
    )
})